// Package labels.v3 defines the protocol buffer services for label management
// within the platform. This service provides CRUD operations for labels and
// their associations with resources.

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file labels/v3/label_service.proto (package labels.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Label, LabelAssociation, LabelScope, LabelSummary, LabelWithActions } from "./label_pb";
import { file_labels_v3_label } from "./label_pb";
import type { SortOrder } from "../../common/v3/common_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Icon } from "../../common/v3/icons_pb";
import { file_common_v3_icons } from "../../common/v3/icons_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file labels/v3/label_service.proto.
 */
export const file_labels_v3_label_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_labels_v3_label, file_common_v3_common, file_common_v3_icons]);

/**
 * Create label request
 *
 * @generated from message labels.v3.CreateLabelRequest
 */
export type CreateLabelRequest = Message<"labels.v3.CreateLabelRequest"> & {
  /**
   * Display name for the label
   *
   * @generated from field: string display_name = 1;
   */
  displayName: string;

  /**
   * Icon for the label
   *
   * @generated from field: common.v3.Icon icon = 2;
   */
  icon: Icon;

  /**
   * Color for the label (hex color code)
   *
   * @generated from field: string color = 3;
   */
  color: string;

  /**
   * Description of the label
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * Scope of the label
   *
   * @generated from field: labels.v3.LabelScope scope = 5;
   */
  scope: LabelScope;

  /**
   * Context for scoped labels
   *
   * @generated from field: optional string organization_id = 6;
   */
  organizationId: string;

  /**
   * @generated from field: optional string workspace_id = 7;
   */
  workspaceId: string;

  /**
   * @generated from field: optional string project_id = 8;
   */
  projectId: string;

  /**
   * @generated from field: string tenant_id = 9;
   */
  tenantId: string;
};

/**
 * Describes the message labels.v3.CreateLabelRequest.
 * Use `create(CreateLabelRequestSchema)` to create a new message.
 */
export const CreateLabelRequestSchema: GenMessage<CreateLabelRequest> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 0);

/**
 * @generated from message labels.v3.CreateLabelResponse
 */
export type CreateLabelResponse = Message<"labels.v3.CreateLabelResponse"> & {
  /**
   * @generated from field: labels.v3.Label label = 1;
   */
  label: Label;
};

/**
 * Describes the message labels.v3.CreateLabelResponse.
 * Use `create(CreateLabelResponseSchema)` to create a new message.
 */
export const CreateLabelResponseSchema: GenMessage<CreateLabelResponse> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 1);

/**
 * Get label request
 *
 * @generated from message labels.v3.GetLabelRequest
 */
export type GetLabelRequest = Message<"labels.v3.GetLabelRequest"> & {
  /**
   * ID of the label to retrieve
   *
   * @generated from field: string label_id = 1;
   */
  labelId: string;
};

/**
 * Describes the message labels.v3.GetLabelRequest.
 * Use `create(GetLabelRequestSchema)` to create a new message.
 */
export const GetLabelRequestSchema: GenMessage<GetLabelRequest> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 2);

/**
 * @generated from message labels.v3.GetLabelResponse
 */
export type GetLabelResponse = Message<"labels.v3.GetLabelResponse"> & {
  /**
   * @generated from field: labels.v3.LabelWithActions label = 1;
   */
  label: LabelWithActions;
};

/**
 * Describes the message labels.v3.GetLabelResponse.
 * Use `create(GetLabelResponseSchema)` to create a new message.
 */
export const GetLabelResponseSchema: GenMessage<GetLabelResponse> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 3);

/**
 * Update label request
 *
 * @generated from message labels.v3.UpdateLabelRequest
 */
export type UpdateLabelRequest = Message<"labels.v3.UpdateLabelRequest"> & {
  /**
   * ID of the label to update
   *
   * @generated from field: string label_id = 1;
   */
  labelId: string;

  /**
   * Version for optimistic concurrency control
   *
   * @generated from field: int64 version = 2;
   */
  version: bigint;

  /**
   * Fields to update
   *
   * @generated from field: optional string display_name = 3;
   */
  displayName: string;

  /**
   * @generated from field: optional common.v3.Icon icon = 4;
   */
  icon: Icon;

  /**
   * @generated from field: optional string color = 5;
   */
  color: string;

  /**
   * @generated from field: optional string description = 6;
   */
  description: string;
};

/**
 * Describes the message labels.v3.UpdateLabelRequest.
 * Use `create(UpdateLabelRequestSchema)` to create a new message.
 */
export const UpdateLabelRequestSchema: GenMessage<UpdateLabelRequest> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 4);

/**
 * @generated from message labels.v3.UpdateLabelResponse
 */
export type UpdateLabelResponse = Message<"labels.v3.UpdateLabelResponse"> & {
  /**
   * @generated from field: labels.v3.Label label = 1;
   */
  label: Label;
};

/**
 * Describes the message labels.v3.UpdateLabelResponse.
 * Use `create(UpdateLabelResponseSchema)` to create a new message.
 */
export const UpdateLabelResponseSchema: GenMessage<UpdateLabelResponse> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 5);

/**
 * Delete label request
 *
 * @generated from message labels.v3.DeleteLabelRequest
 */
export type DeleteLabelRequest = Message<"labels.v3.DeleteLabelRequest"> & {
  /**
   * ID of the label to delete
   *
   * @generated from field: string label_id = 1;
   */
  labelId: string;

  /**
   * Version for optimistic concurrency control
   *
   * @generated from field: int64 version = 2;
   */
  version: bigint;
};

/**
 * Describes the message labels.v3.DeleteLabelRequest.
 * Use `create(DeleteLabelRequestSchema)` to create a new message.
 */
export const DeleteLabelRequestSchema: GenMessage<DeleteLabelRequest> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 6);

/**
 * List labels request
 *
 * @generated from message labels.v3.ListLabelsRequest
 */
export type ListLabelsRequest = Message<"labels.v3.ListLabelsRequest"> & {
  /**
   * Pagination
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * Filtering
   *
   * @generated from field: optional labels.v3.LabelScope scope = 3;
   */
  scope: LabelScope;

  /**
   * @generated from field: optional string organization_id = 4;
   */
  organizationId: string;

  /**
   * @generated from field: optional string workspace_id = 5;
   */
  workspaceId: string;

  /**
   * @generated from field: optional string project_id = 6;
   */
  projectId: string;

  /**
   * Search
   *
   * @generated from field: optional string search_query = 7;
   */
  searchQuery: string;

  /**
   * Include archived labels
   *
   * @generated from field: bool include_archived = 8;
   */
  includeArchived: boolean;

  /**
   * @generated from field: labels.v3.ListLabelsRequest.SortBy sort_by = 9;
   */
  sortBy: ListLabelsRequest_SortBy;

  /**
   * @generated from field: common.v3.SortOrder sort_order = 10;
   */
  sortOrder: SortOrder;
};

/**
 * Describes the message labels.v3.ListLabelsRequest.
 * Use `create(ListLabelsRequestSchema)` to create a new message.
 */
export const ListLabelsRequestSchema: GenMessage<ListLabelsRequest> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 7);

/**
 * Sorting
 *
 * @generated from enum labels.v3.ListLabelsRequest.SortBy
 */
export enum ListLabelsRequest_SortBy {
  /**
   * @generated from enum value: SORT_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SORT_BY_DISPLAY_NAME = 1;
   */
  DISPLAY_NAME = 1,

  /**
   * @generated from enum value: SORT_BY_CREATED_AT = 2;
   */
  CREATED_AT = 2,

  /**
   * @generated from enum value: SORT_BY_UPDATED_AT = 3;
   */
  UPDATED_AT = 3,

  /**
   * @generated from enum value: SORT_BY_USAGE_COUNT = 4;
   */
  USAGE_COUNT = 4,

  /**
   * @generated from enum value: SORT_BY_LAST_USED_AT = 5;
   */
  LAST_USED_AT = 5,
}

/**
 * Describes the enum labels.v3.ListLabelsRequest.SortBy.
 */
export const ListLabelsRequest_SortBySchema: GenEnum<ListLabelsRequest_SortBy> = /*@__PURE__*/
  enumDesc(file_labels_v3_label_service, 7, 0);

/**
 * @generated from message labels.v3.ListLabelsResponse
 */
export type ListLabelsResponse = Message<"labels.v3.ListLabelsResponse"> & {
  /**
   * @generated from field: repeated labels.v3.LabelWithActions labels = 1;
   */
  labels: LabelWithActions[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int64 total_count = 3;
   */
  totalCount: bigint;
};

/**
 * Describes the message labels.v3.ListLabelsResponse.
 * Use `create(ListLabelsResponseSchema)` to create a new message.
 */
export const ListLabelsResponseSchema: GenMessage<ListLabelsResponse> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 8);

/**
 * Associate label request
 *
 * @generated from message labels.v3.AssociateLabelRequest
 */
export type AssociateLabelRequest = Message<"labels.v3.AssociateLabelRequest"> & {
  /**
   * ID of the label to associate
   *
   * @generated from field: string label_id = 1;
   */
  labelId: string;

  /**
   * ID of the resource to label
   *
   * @generated from field: string resource_id = 2;
   */
  resourceId: string;

  /**
   * Type of the resource
   *
   * @generated from field: string resource_type = 3;
   */
  resourceType: string;
};

/**
 * Describes the message labels.v3.AssociateLabelRequest.
 * Use `create(AssociateLabelRequestSchema)` to create a new message.
 */
export const AssociateLabelRequestSchema: GenMessage<AssociateLabelRequest> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 9);

/**
 * @generated from message labels.v3.AssociateLabelResponse
 */
export type AssociateLabelResponse = Message<"labels.v3.AssociateLabelResponse"> & {
  /**
   * @generated from field: labels.v3.LabelAssociation association = 1;
   */
  association: LabelAssociation;
};

/**
 * Describes the message labels.v3.AssociateLabelResponse.
 * Use `create(AssociateLabelResponseSchema)` to create a new message.
 */
export const AssociateLabelResponseSchema: GenMessage<AssociateLabelResponse> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 10);

/**
 * Disassociate label request
 *
 * @generated from message labels.v3.DisassociateLabelRequest
 */
export type DisassociateLabelRequest = Message<"labels.v3.DisassociateLabelRequest"> & {
  /**
   * ID of the label to disassociate
   *
   * @generated from field: string label_id = 1;
   */
  labelId: string;

  /**
   * ID of the resource to unlabel
   *
   * @generated from field: string resource_id = 2;
   */
  resourceId: string;

  /**
   * Type of the resource
   *
   * @generated from field: string resource_type = 3;
   */
  resourceType: string;
};

/**
 * Describes the message labels.v3.DisassociateLabelRequest.
 * Use `create(DisassociateLabelRequestSchema)` to create a new message.
 */
export const DisassociateLabelRequestSchema: GenMessage<DisassociateLabelRequest> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 11);

/**
 * Get resource labels request
 *
 * @generated from message labels.v3.GetResourceLabelsRequest
 */
export type GetResourceLabelsRequest = Message<"labels.v3.GetResourceLabelsRequest"> & {
  /**
   * ID of the resource
   *
   * @generated from field: string resource_id = 1;
   */
  resourceId: string;

  /**
   * Type of the resource
   *
   * @generated from field: string resource_type = 2;
   */
  resourceType: string;
};

/**
 * Describes the message labels.v3.GetResourceLabelsRequest.
 * Use `create(GetResourceLabelsRequestSchema)` to create a new message.
 */
export const GetResourceLabelsRequestSchema: GenMessage<GetResourceLabelsRequest> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 12);

/**
 * @generated from message labels.v3.GetResourceLabelsResponse
 */
export type GetResourceLabelsResponse = Message<"labels.v3.GetResourceLabelsResponse"> & {
  /**
   * @generated from field: repeated labels.v3.LabelSummary labels = 1;
   */
  labels: LabelSummary[];
};

/**
 * Describes the message labels.v3.GetResourceLabelsResponse.
 * Use `create(GetResourceLabelsResponseSchema)` to create a new message.
 */
export const GetResourceLabelsResponseSchema: GenMessage<GetResourceLabelsResponse> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 13);

/**
 * Get label resources request
 *
 * @generated from message labels.v3.GetLabelResourcesRequest
 */
export type GetLabelResourcesRequest = Message<"labels.v3.GetLabelResourcesRequest"> & {
  /**
   * ID of the label
   *
   * @generated from field: string label_id = 1;
   */
  labelId: string;

  /**
   * Pagination
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;

  /**
   * Filter by resource type
   *
   * @generated from field: optional string resource_type = 4;
   */
  resourceType: string;
};

/**
 * Describes the message labels.v3.GetLabelResourcesRequest.
 * Use `create(GetLabelResourcesRequestSchema)` to create a new message.
 */
export const GetLabelResourcesRequestSchema: GenMessage<GetLabelResourcesRequest> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 14);

/**
 * @generated from message labels.v3.GetLabelResourcesResponse
 */
export type GetLabelResourcesResponse = Message<"labels.v3.GetLabelResourcesResponse"> & {
  /**
   * @generated from field: repeated labels.v3.LabelAssociation associations = 1;
   */
  associations: LabelAssociation[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int64 total_count = 3;
   */
  totalCount: bigint;
};

/**
 * Describes the message labels.v3.GetLabelResourcesResponse.
 * Use `create(GetLabelResourcesResponseSchema)` to create a new message.
 */
export const GetLabelResourcesResponseSchema: GenMessage<GetLabelResourcesResponse> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 15);

/**
 * Bulk associate labels request
 *
 * @generated from message labels.v3.BulkAssociateLabelsRequest
 */
export type BulkAssociateLabelsRequest = Message<"labels.v3.BulkAssociateLabelsRequest"> & {
  /**
   * Labels to associate
   *
   * @generated from field: repeated string label_ids = 1;
   */
  labelIds: string[];

  /**
   * Resources to label
   *
   * @generated from field: repeated labels.v3.BulkResourceTarget resources = 2;
   */
  resources: BulkResourceTarget[];
};

/**
 * Describes the message labels.v3.BulkAssociateLabelsRequest.
 * Use `create(BulkAssociateLabelsRequestSchema)` to create a new message.
 */
export const BulkAssociateLabelsRequestSchema: GenMessage<BulkAssociateLabelsRequest> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 16);

/**
 * @generated from message labels.v3.BulkResourceTarget
 */
export type BulkResourceTarget = Message<"labels.v3.BulkResourceTarget"> & {
  /**
   * @generated from field: string resource_id = 1;
   */
  resourceId: string;

  /**
   * @generated from field: string resource_type = 2;
   */
  resourceType: string;
};

/**
 * Describes the message labels.v3.BulkResourceTarget.
 * Use `create(BulkResourceTargetSchema)` to create a new message.
 */
export const BulkResourceTargetSchema: GenMessage<BulkResourceTarget> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 17);

/**
 * @generated from message labels.v3.BulkAssociateLabelsResponse
 */
export type BulkAssociateLabelsResponse = Message<"labels.v3.BulkAssociateLabelsResponse"> & {
  /**
   * @generated from field: repeated labels.v3.LabelAssociation associations = 1;
   */
  associations: LabelAssociation[];

  /**
   * @generated from field: repeated string failed_operations = 2;
   */
  failedOperations: string[];
};

/**
 * Describes the message labels.v3.BulkAssociateLabelsResponse.
 * Use `create(BulkAssociateLabelsResponseSchema)` to create a new message.
 */
export const BulkAssociateLabelsResponseSchema: GenMessage<BulkAssociateLabelsResponse> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 18);

/**
 * Bulk disassociate labels request
 *
 * @generated from message labels.v3.BulkDisassociateLabelsRequest
 */
export type BulkDisassociateLabelsRequest = Message<"labels.v3.BulkDisassociateLabelsRequest"> & {
  /**
   * Labels to disassociate
   *
   * @generated from field: repeated string label_ids = 1;
   */
  labelIds: string[];

  /**
   * Resources to unlabel
   *
   * @generated from field: repeated labels.v3.BulkResourceTarget resources = 2;
   */
  resources: BulkResourceTarget[];
};

/**
 * Describes the message labels.v3.BulkDisassociateLabelsRequest.
 * Use `create(BulkDisassociateLabelsRequestSchema)` to create a new message.
 */
export const BulkDisassociateLabelsRequestSchema: GenMessage<BulkDisassociateLabelsRequest> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 19);

/**
 * Response messages for operations that don't return data
 *
 * @generated from message labels.v3.DeleteLabelResponse
 */
export type DeleteLabelResponse = Message<"labels.v3.DeleteLabelResponse"> & {
};

/**
 * Describes the message labels.v3.DeleteLabelResponse.
 * Use `create(DeleteLabelResponseSchema)` to create a new message.
 */
export const DeleteLabelResponseSchema: GenMessage<DeleteLabelResponse> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 20);

/**
 * @generated from message labels.v3.DisassociateLabelResponse
 */
export type DisassociateLabelResponse = Message<"labels.v3.DisassociateLabelResponse"> & {
};

/**
 * Describes the message labels.v3.DisassociateLabelResponse.
 * Use `create(DisassociateLabelResponseSchema)` to create a new message.
 */
export const DisassociateLabelResponseSchema: GenMessage<DisassociateLabelResponse> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 21);

/**
 * @generated from message labels.v3.BulkDisassociateLabelsResponse
 */
export type BulkDisassociateLabelsResponse = Message<"labels.v3.BulkDisassociateLabelsResponse"> & {
};

/**
 * Describes the message labels.v3.BulkDisassociateLabelsResponse.
 * Use `create(BulkDisassociateLabelsResponseSchema)` to create a new message.
 */
export const BulkDisassociateLabelsResponseSchema: GenMessage<BulkDisassociateLabelsResponse> = /*@__PURE__*/
  messageDesc(file_labels_v3_label_service, 22);

/**
 * LabelService provides operations for managing labels.
 *
 * @generated from service labels.v3.LabelService
 */
export const LabelService: GenService<{
  /**
   * Create a new label
   *
   * @generated from rpc labels.v3.LabelService.CreateLabel
   */
  createLabel: {
    methodKind: "unary";
    input: typeof CreateLabelRequestSchema;
    output: typeof CreateLabelResponseSchema;
  },
  /**
   * Get a label by ID
   *
   * @generated from rpc labels.v3.LabelService.GetLabel
   */
  getLabel: {
    methodKind: "unary";
    input: typeof GetLabelRequestSchema;
    output: typeof GetLabelResponseSchema;
  },
  /**
   * Update an existing label
   *
   * @generated from rpc labels.v3.LabelService.UpdateLabel
   */
  updateLabel: {
    methodKind: "unary";
    input: typeof UpdateLabelRequestSchema;
    output: typeof UpdateLabelResponseSchema;
  },
  /**
   * Delete a label (soft delete)
   *
   * @generated from rpc labels.v3.LabelService.DeleteLabel
   */
  deleteLabel: {
    methodKind: "unary";
    input: typeof DeleteLabelRequestSchema;
    output: typeof DeleteLabelResponseSchema;
  },
  /**
   * List labels accessible to the user
   *
   * @generated from rpc labels.v3.LabelService.ListLabels
   */
  listLabels: {
    methodKind: "unary";
    input: typeof ListLabelsRequestSchema;
    output: typeof ListLabelsResponseSchema;
  },
  /**
   * Associate a label with a resource
   *
   * @generated from rpc labels.v3.LabelService.AssociateLabel
   */
  associateLabel: {
    methodKind: "unary";
    input: typeof AssociateLabelRequestSchema;
    output: typeof AssociateLabelResponseSchema;
  },
  /**
   * Remove a label association from a resource
   *
   * @generated from rpc labels.v3.LabelService.DisassociateLabel
   */
  disassociateLabel: {
    methodKind: "unary";
    input: typeof DisassociateLabelRequestSchema;
    output: typeof DisassociateLabelResponseSchema;
  },
  /**
   * Bulk operations for efficiency
   *
   * @generated from rpc labels.v3.LabelService.BulkAssociateLabels
   */
  bulkAssociateLabels: {
    methodKind: "unary";
    input: typeof BulkAssociateLabelsRequestSchema;
    output: typeof BulkAssociateLabelsResponseSchema;
  },
  /**
   * @generated from rpc labels.v3.LabelService.BulkDisassociateLabels
   */
  bulkDisassociateLabels: {
    methodKind: "unary";
    input: typeof BulkDisassociateLabelsRequestSchema;
    output: typeof BulkDisassociateLabelsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_labels_v3_label_service, 0);

